export default __webpack_public_path__ + "static/media/logo.7eb5bea7.png";